import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue'),
  },
  {
    path: '/portfolio/:category(pharma|fintech)',
    name: 'portfolioCategory',
    component: () => import('../views/PortfolioCategoryView.vue'),
  },
  {
    path: '/portfolio/:category(pharma|fintech)/:slug',
    name: 'projectDetail',
    component: () => import('../views/ProjectDetailView.vue'),
  },
  {
    path: '/who-are-we',
    name: 'whoAreWe',
    component: () => import('../views/WhoAreWeView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.afterEach((to: any) => {
  nextTick(() => {
    if (to.hash) {
      const el = document.querySelector(to.hash)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    } else {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      window.scrollTo(0, 0)
    }
  })
})

export default router
